const OpcionesPagos = ({ rutaimagen, nombrepago, valorpago, onClick }) => {

    return (
            <div className="card-transaction-info"
            onClick={onClick}
            style={{ 
                width: "1000px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                padding: "15px 30px" }}>
                <div className="contenedor-logo-pago">
                    <img
                    style={{ width: "150px", height: "50px" }} src={rutaimagen} />
                </div>
                <div className="conetenedor-informacion-pago">
                    <p style={{ color: "#55ce8d" }}>
                        {nombrepago}
                    </p>
                    <span>
                        <span style={{ color: "#55ce8d" }}>Valor</span> &nbsp;&nbsp; $ {valorpago}
                    </span>
                </div>
            </div>
    )
}

export default OpcionesPagos;